import i18next from 'i18next';
var getAsyncValidationMessage = function (msgKey) {
    return i18next.t("errors:".concat(msgKey), {
        lngs: [i18next.language],
        lng: i18next.language,
    });
};
export { getAsyncValidationMessage };
